export default __webpack_public_path__ + "static/media/verticalogo.ba711779.png";